export enum SliderTypes {
  SLICK_PREV = 'slick-prev',
  SLICK_NEXT = 'slick-next',
  SLICK_DISABLED = 'slick-disabled',
}
